<ng-container *adaptLoading="!isInitialised">
    @if (systems?.length) {
        <div class="top-system-buttons d-flex flex-wrap justify-content-center"
             data-test="top-system-buttons">
            @for (system of systems; track system) {
                <button class="flex-nowrap"
                        adaptButton="pill"
                        [adaptButtonToggle]="selectedSystem === system"
                        (adaptButtonToggleChange)="onToggleChanged($event, system)">
                    @if (selectedSystem === system) {
                        <div class="d-inline-flex flex-nowrap">
                            <a class="text-white"
                               [routerLink]="getSystemPageRoute$(system) | async"
                               adaptTooltip="Navigate to the system page">{{ system.name }}</a>
                            <i class="ms-1 me-n2 fal fa-fw fa-chevron-circle-right navigate-system-icon"
                               adaptTooltip="Navigate to the system page"
                               (click)="gotoSystemPage(system)"></i>
                        </div>
                    } @else {
                        <span>{{ system.name }}</span>
                    }
                </button>
            }
            <div class="d-none d-print-block">
                @for (system of systems; track system) {
                    <div>
                        @if (selectedSystem === system) {
                            <h1>System: {{ system.name }}</h1>
                        }
                    </div>
                }
            </div>
            <button adaptButton="editBorderless"
                    *adaptIfAuthorised="ConfigureSystem; entity: team"
                    adaptTooltip="Add/remove/reorder systems"
                    (click)="editSystemLocations()"
                    data-test="modify-systems-button"></button>
        </div>
        @if (selectedSystem) {
            <div class="mt-2">
                <adapt-system-content [showTitle]="false"
                                      [system]="selectedSystem"
                                      [displayContext]="team || role"
                                      (initialised)="onSystemContentInitialised()"></adapt-system-content>
            </div>
        }
    } @else {
        @if (!hideCTA) {
            <adapt-call-to-action [learnMoreUrl]="learnMoreUrl"
                                  [fullPage]="fullPageCTA">
                <adapt-call-to-action-title [iconClass]="systemsIcon"> Systemisation </adapt-call-to-action-title>

                <p>Once your leadership team has understanding and agreement around the Key Functions and better role clarity, it's time to
                    document the most important processes so those involved in executing can be more effective in their work and the
                    business can be consistent in how it does things.</p>

                <button adaptButtonIcon="add"
                        adaptCallToActionButton
                        *adaptIfAuthorised="ConfigureSystem; entity: team"
                        class="mt-1"
                        (click)="editSystemLocations()"
                        data-test="modify-systems-button">Add system</button>
            </adapt-call-to-action>
        }
    }
</ng-container>
